import { render, staticRenderFns } from "./Games.vue?vue&type=template&id=6f72bcc3&scoped=true&lang=html&"
import script from "./Games.vue?vue&type=script&lang=js&"
export * from "./Games.vue?vue&type=script&lang=js&"
import style0 from "./Games.vue?vue&type=style&index=0&id=6f72bcc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72bcc3",
  null
  
)

component.options.__file = "Games.vue"
export default component.exports